import { DirectionalLight } from 'three';

function createLights() {
  // 创建一个强度为 8 的纯白光
  const light = new DirectionalLight('white', 8);

  // 灯光从(10,10,10)照向(0,0,0)
  light.position.set(10, 10, 10);

  return light;
}

export { createLights };